import { Navigate, useRoutes } from 'react-router-dom';

import { PATH_AFTER_LOGIN } from 'src/config-global';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { adminRoutes } from './admin';
import { lockerRoutes } from './locker';
import { portalRoutes } from './portal';
import { reportsRoutes } from './reports';
import { billingRoutes } from './billing';
import { courierRoutes } from './courier';
import { settingsRoutes } from './settings';
import { shippingRoutes } from './shipping';
import { receptionRoutes } from './reception';
import { procedureRoutes } from './procedure';
import { dashboardRoutes } from './dashboard';
import { cashCloseRoutes } from './cash-close';
import { managementRoutes } from './management';
import { distributionRoutes } from './distribution';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    }, // SET INDEX PAGE WITH HOME PAGE
    // {
    //   path: '/',
    //   element: (
    //     <MainLayout>
    //       <HomePage />
    //     </MainLayout>
    //   ),
    // },    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Billing routes (owner-only, #59)
    ...billingRoutes,

    // Owner cash-close route (owner-only, #123)
    ...cashCloseRoutes,

    // Management routes
    ...managementRoutes,

    // Settings routes
    ...settingsRoutes,

    // Reports routes
    ...reportsRoutes,

    // Main routes
    ...mainRoutes,

    // Procedure routes
    ...procedureRoutes,

    // Shipping routes
    ...shippingRoutes,

    // Reception routes (standalone, separate auth)
    ...receptionRoutes,

    // Distribution client routes
    ...distributionRoutes,

    // Locker routes
    ...lockerRoutes,

    // Client portal routes
    ...portalRoutes,

    // Public courier capture route (#106) — token-gated, OUTSIDE AuthGuard.
    ...courierRoutes,

    // Platform admin portal routes (epic #45)
    ...adminRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
